<script setup lang="ts">
import contactOptionsConfig from "../config/contactOptions";

const props = withDefaults(defineProps<{ configId?: string }>(), {
  configId: 'default'
})

defineEmits<{
  (e: 'next', step): void
  (e: 'back'): void
}>()
</script>

<template>
  <div class="space-y-3">
    <button class="w-full rounded-lg border border-solid border-gray-500 bg-white py-3 text-sm text-gray-600 hover:bg-gray-50" @click="$emit('next', 'whatsapp', { phones: contactOptionsConfig[props.configId]['whatsapp'] })">
      Por WhatsApp
    </button>
    <button class="w-full rounded-lg border border-solid border-gray-500 bg-white py-3 text-sm text-gray-600 hover:bg-gray-50" @click="$emit('next', 'store', { stores: contactOptionsConfig[props.configId]['store'] })">
      Pedir cita en tienda
    </button>
    <button class="w-full rounded-lg border border-solid border-gray-500 bg-white py-3 text-sm text-gray-600 hover:bg-gray-50" @click="$emit('next', 'iFrameNexor', contactOptionsConfig[props.configId]['iFrameNexor'])">
      Por email
    </button>
    <button class="w-full rounded-lg border border-solid border-gray-500 bg-white py-3 text-sm text-gray-600 hover:bg-gray-50" @click="$emit('next', 'phone', { phones: contactOptionsConfig[props.configId]['phone'] })">
      Por teléfono
    </button>
  </div>
</template>
